import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSriLanka = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_29_949)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M6.25001e-05 2.08698H0V21.913H6.25001e-05V12.0001V2.08698Z",
				fill: "#FF9811"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37257 18.6274 0 12 0C5.37257 0 0 5.37257 0 12C0 18.6274 5.37257 24 12 24Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M9.39137 2.08698H5.2366C5.05247 2.21283 4.87229 2.34385 4.69571 2.47946L3.65222 12L4.69571 21.5205C4.87229 21.6561 5.05247 21.7872 5.2366 21.913H9.39137V2.08698Z",
				fill: "#FF9811"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0 12.0001C0 15.8788 1.84069 19.327 4.69567 21.5206V2.47951C1.84069 4.67317 0 8.1214 0 12.0001Z",
				fill: "#6DA544"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M19.3044 7.31552V7.61576L19.3156 7.61744L19.3044 7.31552Z",
				fill: "#FFDA44"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M23.0435 15.1304H20.7826L19.8261 16.1739V18.2609H17.7391V17.2174H18.7826V15.1304H14.087V16.4348H13.0435V13.9489C12.7233 13.6624 12.5217 13.2461 12.5217 12.7826V6.00001C12.5217 5.13559 13.2225 4.43481 14.087 4.43481V14.087H16.1739L16.89 13.4902C16.7649 13.1923 16.6956 12.8652 16.6956 12.5218V10.9566H15.1304V7.82617H18.2608C18.2608 7.30445 19.0435 6.78269 19.0435 6.78269C19.0435 6.78269 19.8261 7.30441 19.8261 7.82617V8.6088V10.9566C20.4066 10.9635 21.3288 10.9485 22.3251 10.9566C22.0634 10.4991 21.913 9.95627 21.913 9.39143C21.913 8.47075 22.3105 7.64303 22.9432 7.07022C22.0312 5.0492 20.576 3.32598 18.7634 2.08698H10.9565V21.9131H18.7635C20.9675 20.4065 22.6432 18.1841 23.4562 15.5807L23.0435 15.1304Z",
				fill: "#A2001D"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_29_949",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgSriLanka;
